module.exports = "/images/vendor/flag-icon-css/flags/1x1/bm.svg?09839e2cd707999b472d6631640dba1c";